export default __webpack_public_path__ + "static/media/card4.36c26362.png";